const INSERT_BEFORE_OR_REMOVE_CHILD = /Failed to execute '(insertBefore|removeChild)' on 'Node'/;
const NOT_A_CHILD = /is not a child of this node/;

let installed = false;

/**
 * Chrome / Edge in-page translate wraps text nodes (usually in <font>).
 * React then calls insertBefore / removeChild with a stale reference and
 * throws NotFoundError, which takes down the nearest error boundary.
 *
 * The parent-mismatch branches only run when something else already moved
 * the node. Healthy React updates are unchanged.
 *
 * @see https://github.com/facebook/react/issues/11538
 */
export function isTranslateDomError(error) {
  if (!error) return false;

  const name = error.name || error.errorClass || '';
  const message = error.message || error.errorMessage || String(error);

  if (name !== 'NotFoundError' && name !== 'DOMException') return false;
  return INSERT_BEFORE_OR_REMOVE_CHILD.test(message) && NOT_A_CHILD.test(message);
}

export function installTranslateDomGuard() {
  if (installed) return;
  if (typeof Node !== 'function' || !Node.prototype) return;

  installed = true;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChildGuarded(child) {
    if (child && child.parentNode !== this) {
      if (child.parentNode) {
        return originalRemoveChild.call(child.parentNode, child);
      }
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBeforeGuarded(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}
